import React from "react";
import {ContextPropsProvider} from "./Components/StateManager";
import {providers} from "./Components/StateManager/Context";
import {AppRouter} from "./SiteConfig/Routes/AppRouter";
import "./sass/main.scss";

export function App() {
    return (
        <ContextPropsProvider providers={providers}>
            <AppRouter/>
        </ContextPropsProvider>
    );
}